import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import golf from "../../../assets/images/2025-Program/golf-ball-flag.jpg";

import { useSelector } from "react-redux";
// import Sidebar from "../../../../layouts/sidebar/sidebar";
// import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../constant/images";
import sinta from "../../../assets/images/GTM-APP-icons/gold-sinta.png";
import { FaClock, FaLocationDot, FaUser, FaUsers } from "react-icons/fa6";
import event_img from "../../../assets/images/GTM-APP-icons/event_img.png";
import { Modal, message } from "antd";
import { FaCalendarAlt, FaGolfBall } from "react-icons/fa";
import Header from "../../../layouts/header";
import { useTranslation } from "react-i18next";

export default function ProgramShow() {
  const navigate = useNavigate();
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const location = useLocation();
  const { eventId, pack, membershipId, isGolfer, memberId } = location.state;
  console.log("location.state", location.state);

  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");

  // State variables from React Native version
  const [event, setEvent] = useState(null);
  const [eventMessage, setEventMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [attending, setAttending] = useState(false);
  const [eventAttendance, setEventAttendance] = useState(null);
  const [oneTypeAllowedPacks, setOneTypeAllowedPacks] = useState([]);
  const [manyTypes, setManyTypes] = useState([]);
  const [typeLimit, setTypeLimit] = useState(null);
  const [packYearlyLimit, setPackYearlyLimit] = useState(0);
  const [memberTotalAttendanceCount, setMemberTotalAttendanceCount] =
    useState(0);
  const [memberTypeCount, setMemberTypeCount] = useState(0);
  const [golfersCount, setGolfersCount] = useState(0);
  const [nonGolfersCount, setNonGolfersCount] = useState(0);
  const [eventHappened, setEventHappened] = useState(false);
  const [filterActivated, setFilterActivated] = useState(false);
  const [user, setUser] = useState(null);
  const [canFetch, setCanFetch] = useState(false);
  const [membership, setMembership] = useState(null);
  const [enterBlock2, setEnterBlock2] = useState(false);
  const [disableButton2, setDisableButton2] = useState(false);

  // const { i18n, t } = useTranslation();
  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  // };
  // Fetch user data
  const fetchUser = useCallback(async () => {
    const token = localStorage.getItem("userToken");
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
        setMembership(response.data?.membership);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    } finally {
      setCanFetch(true);
    }
  }, [baseUrl]);

  const fetchEvent = async () => {
    try {
      setIsLoading(true);

      const response = await axios.get(`${baseUrl}/events/${eventId}`, {
        params: {
          membership_id: membershipId,
          memberId: memberId,
        },
        withCredentials: true,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      if (
        response?.data?.event?.golfeurs == null &&
        response?.data?.event?.non_golfeurs == null
      ) {
        setFilterActivated(false);
        setEnterBlock2(true);
      } else {
        setFilterActivated(true);
      }

      setEvent(response?.data?.event);
      setEventHappened(response?.data?.eventHappened);
      setEventAttendance(response?.data?.eventAttendanceCount);
      const packLimit = response?.data?.packYearlyCount;
      setMemberTotalAttendanceCount(response?.data?.memberTotalAttendance);
      setPackYearlyLimit(packLimit);
      setGolfersCount(response?.data?.golfersCount);
      setNonGolfersCount(response?.data?.nonGolfersCount);

      if (response?.data?.event?.event_types?.length > 1) {
        if (user?.golfeurs === "Yes" || user?.golfeurs === "Oui") {
        } else {
        }
        if (response?.data?.isVip == "Yes") {
          const newTypes = response?.data?.event?.event_types?.map((type) => ({
            eventType: type?.type,
            eventTypeId: type?.id,
            allowedPacks: type?.allowed_packs?.map(
              (allowedPack) => allowedPack?.name
            ),
            limitation:
              response?.data?.VipMemberLimits?.find(
                (vipMemberLimit) => vipMemberLimit?.event_type_id == type?.id
              )?.additional_limit +
              type?.limitations?.find(
                (limitation) => limitation?.pack_id == membershipId
              )?.limit,
            memberAttendance: response?.data?.memberAttendance,
          }));

          setManyTypes(newTypes);
        } else {
          const newTypes = response?.data?.event?.event_types?.map((type) => ({
            eventType: type?.type,
            eventTypeId: type?.id,
            allowedPacks: type?.allowed_packs?.map(
              (allowedPack) => allowedPack?.name
            ),
            limitation: type?.limitations?.find(
              (limitation) => limitation?.pack_id == membershipId
            )?.limit,
            memberAttendance: response?.data?.memberAttendance,
          }));

          setManyTypes(newTypes);
        }
      } else {
        response?.data?.event?.event_types?.forEach((type) => {
          setOneTypeAllowedPacks(
            type?.allowed_packs?.map((membership) => membership?.name)
          );
        });

        setMemberTypeCount(response?.data?.memberTypeCount);
        setTypeLimit(response?.data?.limit);

        if (user?.golfeurs === "Yes" || user?.golfeurs === "Oui") {
        } else {
        }
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
      setCanFetch(false);
    }
  };
  useEffect(() => {
    fetchUser();
  }, []);

  useEffect(() => {
    if (canFetch) {
      fetchEvent();
    }
  }, [canFetch, membership, fetchEvent]);

  // Event availability checks (same logic as React Native)
  useEffect(() => {
    if (!isLoading) {
      // checking if the event happened
      if (eventHappened) {
        setDisableButton(true);
        setEventMessage("Event already happened.");
      } else {
        // checking if the event is sold out
        if (event?.sold_out == 1) {
          setDisableButton(true);
          setEventMessage("Event is sold out.");
        } else {
          // setDisableButton(false);
          // setEventMessage(null);
          // setEnterBlock2(true);

          if (memberId) {
            if (event?.event_attendees?.length >= 1) {
              // checking if the member data is found in the array
              const isAttending = event?.event_attendees?.some(
                (eventAttendee) =>
                  eventAttendee.pivot?.membership_id == memberId &&
                  eventAttendee.pivot?.event_id == event.id
              );

              // setting the attending state based on the isAttendig value
              if (isAttending) {
                setAttending(true);
              } else {
                setAttending(false);
                // checking if the event is sold out then if the count of golfers or non-golfer reached the limit. if not checking for memberships and types of event that they can confirm participation in.
                if (eventAttendance == event?.attendees) {
                  setDisableButton(true);
                  setEventMessage(
                    "Event has reached the maximum attendees limit."
                  );
                  setEnterBlock2(false);
                } else {
                  // start of the golfer or non-golfer check
                  if (!filterActivated) {
                    setDisableButton(false);
                    setEventMessage(null);
                    setEnterBlock2(true);
                  } else {
                    if (user?.golfeurs == "Oui" || user?.golfeurs == "Yes") {
                      if (event?.golfeurs == 0) {
                        setDisableButton(true);
                        setEventMessage("Golfers not allowed.");
                        setEnterBlock2(false);
                      } else {
                        if (golfersCount == event?.golfeurs) {
                          setDisableButton(true);
                          setEventMessage(
                            "Event has reached the golfers limit."
                          );
                          setEnterBlock2(false);
                        } else {
                          setDisableButton(false);
                          setEventMessage(null);
                          setEnterBlock2(true);
                        }
                      }
                    } else {
                      if (event?.non_golfeurs == 0) {
                        setDisableButton(true);
                        setEventMessage("Non golfers not allowed.");
                        setEnterBlock2(false);
                      } else {
                        if (nonGolfersCount == event?.non_golfeurs) {
                          setDisableButton(true);
                          setEventMessage(
                            "Event has reached the non golfers limit."
                          );
                          setEnterBlock2(false);
                        } else {
                          setDisableButton(false);
                          setEventMessage(null);
                          setEnterBlock2(true);
                        }
                      }
                    }
                  }

                  if (enterBlock2) {
                    if (memberId) {
                      if (event?.event_types?.length > 1) {
                        if (memberTotalAttendanceCount == packYearlyLimit) {
                          setDisableButton(true);

                          setEventMessage(
                            "Membership limit.You need to upgrade you're membership in order to participate in more events."
                          );
                        } else {
                          setDisableButton(false);
                          // setDisableButton2(false);
                          setEventMessage(null);
                        }
                      } else {
                        if (memberTotalAttendanceCount == packYearlyLimit) {
                          setDisableButton(true);

                          setEventMessage(
                            "Membership limit.You need to upgrade you're membership in order to participate in more events."
                          );
                        } else {
                          if (oneTypeAllowedPacks?.includes(pack)) {
                            setDisableButton(false);
                            setDisableButton2(false);
                            setEventMessage(null);
                          } else {
                            setDisableButton(true);

                            setEventMessage(
                              "You need to upgrade you're membership in order to participate in this event."
                            );
                          }
                        }
                      }
                    } else {
                      setDisableButton(true);

                      setEventMessage(
                        "Only paid members can confirm attendance."
                      );
                    }
                  }
                }
              }
            } else {
              setAttending(false);
            }
          } else {
            setDisableButton(true);

            setEventMessage("Only paid members can confirm attendance.");
          }
        }
      }
    }
  }, [event, isLoading, membership, user, filterActivated]);

  // Attendance confirmation (full logic from React Native)
  const confirmAttendance = async (event_type, eventTypeId) => {
    if (event?.event_types?.length > 1) {
      // find the objet with its attendance count
      let limitReached;
      manyTypes?.map((item) => {
        if (
          item?.memberAttendance?.find(
            (attendance) => attendance?.event_type_id == item?.eventTypeId
          )?.attendance_count == item?.limitation
        ) {
          limitReached = true;
        } else {
          limitReached = false;
        }
      });
      const isAllowed = manyTypes?.some(
        (item) =>
          item?.eventType === event_type && item?.allowedPacks?.includes(pack)
      );
      if (limitReached) {
        alert(
          "Membership limit.You need to upgrade you're membership in order to participate in more events."
        );
      } else {
        if (!isAllowed) {
          alert("You need to upgrade your membership!");
        } else {
          const response = await axios.post(
            `${baseUrl}/confirm-event`,
            {
              memberId: memberId,
              eventId: eventId,
              eventTypeId: eventTypeId,
            },
            {
              withCredentials: true,
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              }
            }
          );
          if (response?.data?.success == "Attendance confirmed.") {
            alert(
              "Attendance confirmed. You can't cancel the attendance 2 days before the event."
            );
            setAttending(true);
            setCanFetch(true);
          }
        }
      }
    } else {
      if (typeLimit == memberTypeCount) {
        alert(
          "Membership limit.You need to upgrade you're membership in order to participate in more events."
        );
      } else {
        if (!oneTypeAllowedPacks?.includes(pack)) {
          alert("You need to upgrade your membership!");
        } else {
          const response = await axios.post(
            `${baseUrl}/confirm-event`,
            {
              memberId: memberId,
              eventId: eventId,
              eventTypeId: eventTypeId,
            },
            {
              withCredentials: true,
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              }
            }
          );
          if (response?.data?.success == "Attendance confirmed.") {
            alert(
              "Attendance confirmed. You can't cancel the attendance when there's 2 days left to the event."
            );
            setAttending(true);
            setCanFetch(true);
          }
        }
      }
    }
  };

  // Attendance cancellation (full logic from React Native)
  const cancelAttendance = async (event_id, event_type_id) => {
    const response = await axios.post(
      `${baseUrl}/cancel-attendance`,
      {
        memberId: memberId,
        eventId: event_id,
        eventTypeId: event_type_id,
      },
      {
        withCredentials: true,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }
    );

    if (response?.status == 200) {
      alert(response?.data?.message);

      if (
        response?.data?.message ==
        "Attendance canceled successfully, you can confirm it again if there's enough places left."
      ) {
        setCanFetch(true);
        setAttending(false);
      } else {
        setAttending(true);
      }
    }
  };

  // const packGradients = {
  //   "non-golfer": {
  //     colors: ["#441903", "#FF6F3F", "#FFA47F", "#CA5730", "#442525"],
  //     locations: [0, 0.25, 0.5, 0.75, 1.0],
  //   },
  //   golfer: {
  //     colors: [
  //       "#884F00",
  //       "#8E5709",
  //       "#9D6B21",
  //       "#B68C49",
  //       "#D8BA80",
  //       "#FFEFBF",
  //       "#DDC28D",
  //       "#C19C62",
  //       "#A97C3F",
  //       "#976423",
  //       "#895210",
  //       "#824704",
  //       "#7F4400",
  //     ],
  //     locations: [
  //       0.01, 0.06, 0.15, 0.25, 0.38, 0.51, 0.58, 0.65, 0.72, 0.79, 0.86, 0.93,
  //       1.0,
  //     ],
  //   },
  //   "golfer+": {
  //     colors: [
  //       "#5C5C5C",
  //       "#6C6C6C",
  //       "#A5A5A5",
  //       "#BCBCBC",
  //       "#D6D6D6",
  //       "#C1C1C1",
  //       "#8A8A8A",
  //       "#474747",
  //     ],
  //     locations: [0, 0.02, 0.11, 0.15, 0.49, 0.53, 0.79, 1.0],
  //   },
  //   default: {
  //     colors: ["#608d40", "#608d40"],
  //     locations: [0, 0.5],
  //   },
  // };

  // function getGradientStyle(pack) {
  //   const gradientConfig = packGradients[pack] || packGradients.default;

  //   // Create color stops by combining colors and locations
  //   const colorStops = gradientConfig.colors
  //     ?.map(
  //       (color, index) => `${color} ${gradientConfig.locations[index] * 100}%`
  //     )
  //     .join(", ");

  //   return `linear-gradient(90deg, ${colorStops})`;
  // }

  const getimagess = (packType) => {
    if (packType) {
      return `${membership?.membership_packs?.background}`;
    }

    return "https://sysgtm.gtm.ma//images/packs/visitor-menu.png";
  };
  const imagess2 = getimagess(membership?.membership_packs?.background);

  if (isLoading) {
    return (
      <div>
        <Header image={golf} title={t("gtm_club_content.programme")} />
        <div className="bg-white min-h-screen bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] py-8 md:py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      </div>
    );
  }

  if (!event) {
    return (
      <div>
        <Header image={golf} title={t("gtm_club_content.programme")} />
        <div className="bg-white min-h-screen bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] py-8 md:py-12">
          <p>Event not found</p>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return new Date(dateString).toLocaleDateString("fr-FR", options);
  };

  function capitalize(str) {
    return str && typeof str === "string"
      ? str.charAt(0).toUpperCase() + str.slice(1)
      : str;
  }

  return (
    <>
      <Header image={golf} title={t("gtm_club_content.programme")} />
      <div
        className={`bg-white  bg-opacity-[87%]  h-full flex flex-col justify-start items-center px-4 md:px-16 gap-4 md:gap-8 w-full  ${
          user ? "md:w-[100%]" : "md:w-[100%]"
        }  py-8 md:py-16`}
      >
        {/* <div className="text-center text-2xl md:text-4xl font-bold mb-2 md:mb-3">
          <p>{language === "fr" ? "Programme 2025" : "2025 Program"}</p>
        </div> */}
        <div className="flex flex-col gap-6 md:gap-12 rounded-lg w-full">
          <div>
            <strong className="text-lg md:text-xl">
              <strong className="text-lg md:text-xl">
                {event?.date
                  ? new Date(event.date).toLocaleDateString(
                      language === "fr" ? "fr-FR" : "en-US",
                      {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }
                    )
                  : ""}
              </strong>
            </strong>
          </div>
          <div className="flex flex-col justify-center gap-6 md:gap-12 items-center w-full">
            <div className="w-full flex justify-center">
              <img
                src={event.photo}
                className="w-full lg:max-w-[350px] max-w-[200px]"
                alt="Event"
              />
            </div>

            <div className="flex flex-col justify-center items-center gap-4 md:gap-8 px-4 md:px-16 w-full">
              <div className="font-bold text-center mt-2 md:mt-4 text-xl md:text-3xl">
                {event.title}
              </div>
              <div className="leading-relaxed md:leading-loose flex flex-col gap-2 md:gap-4 text-sm md:text-base">
                {event.details.split("\n")?.map((paragraph, index) => (
                  <span key={index}>{paragraph}</span>
                ))}
              </div>
              <div className="flex flex-col justify-start gap-2 md:gap-3 w-full">
                <strong className="text-base md:text-lg">
                  {language === "fr"
                    ? "Détails de l'événement :"
                    : "Event details :"}
                </strong>
                <div className="flex gap-1">
                  <div className="flex flex-col gap-2 md:gap-3 justify-start items-start text-sm md:text-base">
                    <span className="flex items-center gap-1">
                      <FaCalendarAlt
                        color="red"
                        className="text-gray-500 text-sm md:text-base"
                      />
                      <strong>{language === "fr" ? "Date" : "Date"}</strong>:{" "}
                      {event?.date
                        ? new Date(event.date).toLocaleDateString(
                            language === "fr" ? "fr-FR" : "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )
                        : ""}
                    </span>
                    <span className="flex items-center gap-1">
                      <FaClock
                        color="red"
                        className="text-gray-500 text-sm md:text-base"
                      />
                      <strong>{language === "fr" ? "Heure" : "Time"}</strong>:{" "}
                      {event.time || language === "fr" ? "À annoncer" : "To be announced"}
                    </span>
                    <span className="flex items-center gap-1">
                      <FaLocationDot
                        color="red"
                        className="text-sm md:text-base"
                      />
                      <strong>{language === "fr" ? "Lieu" : "Venue"}</strong>:{" "}
                      {event.venue}
                    </span>
                    {event.attendees && (
                      <span className="flex items-center gap-1">
                        <FaUsers
                          color="red"
                          className="text-gray-500 text-sm md:text-base"
                        />
                        <strong>
                          {language === "fr" ? "Capacité" : "Capacity"}
                        </strong>
                        : {event.attendees} {language === "fr" ? "participant" : "attendee"}
                      </span>
                    )}
                    {event.golfeurs !== null && (
                      <span className="flex items-center gap-1">
                        <FaGolfBall
                          color="red"
                          className="text-gray-500 text-sm md:text-base"
                        />
                        <strong>
                          {language === "fr" ? "Golfers" : "Golfers"}
                        </strong>
                        : {event.golfeurs}
                      </span>
                    )}
                    {event.non_golfeurs !== null && (
                      <span className="flex items-center gap-1">
                        <FaUser
                          color="red"
                          className="text-gray-500 text-sm md:text-base"
                        />
                        <strong>
                          {language === "fr" ? "Non-golfers" : "Non-golfers"}
                        </strong>
                        : {event.non_golfeurs}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {eventMessage && (
                <div className="text-red-500 text-center text-sm md:text-base mt-1">
                  {eventMessage}
                </div>
              )}

              {membership ? (
                <button
                  onClick={() => setModalVisible(true)}
                  disabled={disableButton}
                  className={`text-white shadow-button hover:opacity-70 text-center w-full md:w-1/3 mt-4 md:mt-1 mb-2 md:mb-4 font-bold p-2 md:p-3 px-4 md:px-[3rem] rounded-3xl text-sm md:text-base ${
                    disableButton ? "bg-gray-400" : "bg-gtm-green"
                  }`}
                >
                  {attending ? "Annuler" : "Confirmer"}
                </button>
              ) : (
                <button
                  onClick={() => navigate("/membership/demande")}
                  className="text-white shadow-button hover:opacity-70 text-center w-full md:w-1/3 mt-1 md:mt-1 mb-2 md:mb-4 font-bold bg-gtm-green p-2 md:p-3 px-4 md:px-[3rem] rounded-3xl text-sm md:text-base"
                >
                  Upgrade
                </button>
              )}
            </div>
          </div>
          <div
            style={{
              height: "15px",
              width: "100%",
              marginTop: "10px",
              borderBottomLeftRadius: "5px",
              borderBottomRightRadius: "5px",
              backgroundImage: imagess2
                ? `url(${imagess2})`
                : `url(https://sysgtm.gtm.ma//images/packs/visitor-menu.png)`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
        </div>
      </div>

      <Modal
        title={attending ? "Cancel Attendance" : "Confirm Attendance"}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        {event.event_types?.map((type) => {
          const isAttending = event?.event_attendees?.some(
            (eventAttendee) =>
              eventAttendee.pivot?.membership_id == memberId &&
              eventAttendee.pivot?.event_id == event.id &&
              eventAttendee.pivot?.event_type_id == type.id
          );
          let isAllowed;
          if (event?.event_types.length > 1) {
            let limitReached;
            manyTypes?.map((item) => {
              if (
                item.memberAttendance?.find(
                  (attendance) => attendance.event_type_id == item.eventTypeId
                )?.attendance_count == item?.limitation
              ) {
                limitReached = true;
              } else {
                limitReached = false;
              }
            });

            isAllowed = manyTypes?.some(
              (item) =>
                item.eventType === type.type &&
                item.allowedPacks?.includes(pack) &&
                !limitReached
            );
          } else {
            if (typeLimit == memberTypeCount) {
              isAllowed = false;
            } else {
              if (oneTypeAllowedPacks.includes(pack)) {
                isAllowed = true;
              }
            }
          }

          return (
            <div
              key={type.id}
              className="flex justify-between items-center mb-4 p-2 border-b"
            >
              <div>
                <h4 className="font-medium">{type.type}</h4>
                {!isAllowed && (
                  <p className="text-red-500 text-sm">
                    Membership upgrade required
                  </p>
                )}
              </div>

              {isAttending ? (
                <button
                  onClick={() => cancelAttendance(event.id, type.id)}
                  className="bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded"
                >
                  Cancel
                </button>
              ) : (
                <button
                  onClick={() => confirmAttendance(type.type, type.id)}
                  disabled={!isAllowed}
                  className={`px-4 py-1 rounded ${
                    isAllowed
                      ? "bg-green-500 hover:bg-green-600 text-white"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  }`}
                >
                  Confirm
                </button>
              )}
            </div>
          );
        })}
      </Modal>
    </>
  );

  //   return (
  //     <div
  //       className="flex flex-col gap-12 min-h-screen"
  //       style={{
  //         backgroundImage: `url(${images.golf_field})`,
  //         backgroundPosition: "center",
  //         backgroundSize: "cover",
  //         backgroundRepeat: "no-repeat",
  //         backgroundAttachment: "fixed",
  //       }}
  //     >
  //       <Nav />
  //       <div className="flex justify-center mx-16 mb-20">
  //         <div className="flex w-full justify-between items-start">
  //           <Sidebar />
  //           <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-start items-center px-16 gap-8 w-[75%] rounded-3xl py-16">
  //             <div className="text-center text-4xl font-bold mb-3">
  //               <p>Programme 2025</p>
  //             </div>
  //             <div className="flex flex-col gap-12 rounded-lg">
  //               <div>
  //                 <strong>{formatDate(event.date)}</strong>
  //               </div>
  //               <div className="flex flex-col justify-center gap-12 items-center">
  //                 <div>
  //                   <img src={event.photo} width={350} alt="Event" />
  //                 </div>

  //                 <div className="flex flex-col justify-center items-center gap-8 px-16">
  //                   <div className="font-bold text-center mt-4 text-3xl">
  //                     {event.title}
  //                   </div>
  //                   <div className="leading-loose flex flex-col gap-4">
  //                     {event.details.split("\n")?.map((paragraph, index) => (
  //                       <span key={index}>{paragraph}</span>
  //                     ))}
  //                   </div>
  //                   <div className="flex flex-col justify-start gap-3 w-full">
  //                     <strong>Détails de l'événement : </strong>
  //                     <div className="flex gap-1">
  //                       <FaLocationDot color="red" className="self-end mb-1" />
  //                       <div className="flex flex-col gap-3 justify-start items-start">
  //                         <span>
  //                           <strong>Date</strong> : {formatDate(event.date)}
  //                         </span>
  //                         <span>
  //                           <strong>Heure</strong> :{" "}
  //                           {event.time || "To be announced"}
  //                         </span>
  //                         <span className="flex items-center gap-1">
  //                           <strong>Lieu</strong> : {event.venue}
  //                         </span>
  //                         {event.attendees && (
  //                           <span>
  //                             <strong>Capacity</strong>: {event.attendees}{" "}
  //                             attendees
  //                           </span>
  //                         )}
  //                         {event.golfeurs !== null && (
  //                           <span>
  //                             <strong>Golfers</strong>: {event.golfeurs}
  //                           </span>
  //                         )}
  //                         {event.non_golfeurs !== null && (
  //                           <span>
  //                             <strong>Non-golfers</strong>: {event.non_golfeurs}
  //                           </span>
  //                         )}
  //                       </div>
  //                     </div>
  //                   </div>

  //                   {eventMessage && (
  //                     <div className="text-red-500 text-center">
  //                       {eventMessage}
  //                     </div>
  //                   )}

  //                   {membership ? (
  //                     <button
  //                       onClick={() => setModalVisible(true)}
  //                       disabled={disableButton}
  //                       className={`text-white shadow-button hover:opacity-70 text-center w-1/3 mt-8 mb-4 font-bold p-3 px-[3rem] rounded-3xl ${
  //                         disableButton ? "bg-gray-400" : "bg-gtm-green"
  //                       }`}
  //                     >
  //                       {attending ? "Annuler" : "Confirmer"}
  //                     </button>
  //                   ) : (
  //                     <button
  //                       onClick={() => navigate("/membership/demande")}
  //                       className="text-white shadow-button hover:opacity-70 text-center w-1/3 mt-8 mb-4 font-bold bg-gtm-green p-3 px-[3rem] rounded-3xl"
  //                     >
  //                       Upgrade
  //                     </button>
  //                   )}
  //                 </div>
  //               </div>
  //               <div
  //                 style={{
  //                   height: "10px",
  //                   width: "100%",
  //                   marginTop: "10px",
  //                   borderBottomLeftRadius: "5px",
  //                   borderBottomRightRadius: "5px",
  //                   background: getGradientStyle(
  //                     membership?.membership_packs?.name?.toLowerCase()
  //                   ),
  //                   backgroundSize: "cover",
  //                   backgroundPosition: "center",
  //                 }}
  //               />
  //             </div>
  //           </div>
  //         </div>
  //       </div>

  //       {/* Confirmation Modal with all event types */}
  //       <Modal
  //         title={attending ? "Cancel Attendance" : "Confirm Attendance"}
  //         open={modalVisible}
  //         onCancel={() => setModalVisible(false)}
  //         footer={null}
  //       >
  //         {event.event_types?.map((type) => {
  //           const isAttending = event?.event_attendees?.some(
  //             (eventAttendee) =>
  //               eventAttendee.pivot?.membership_id == memberId &&
  //               eventAttendee.pivot?.event_id == event.id &&
  //               eventAttendee.pivot?.event_type_id == type.id
  //           );
  //           let isAllowed;
  //           if (event?.event_types.length > 1) {
  //             console.log(
  //               `    Many types array == ${JSON.stringify(manyTypes)}
  // `
  //             );

  //             let limitReached;
  //             manyTypes?.map((item) => {
  //               if (
  //                 item.memberAttendance?.find(
  //                   (attendance) => attendance.event_type_id == item.eventTypeId
  //                 )?.attendance_count == item?.limitation
  //               ) {
  //                 console.log('yeeeees');
  //                 limitReached = true;
  //               } else {
  //                 console.log('noooo');
  //                 limitReached = false;
  //               }
  //             });

  //             // && !(item?.limit == memberTypeCount)

  //             isAllowed = manyTypes?.some(
  //               (item) =>
  //                 item.eventType === type.type &&
  //                 item.allowedPacks?.includes(pack) &&
  //                 !limitReached
  //             );
  //           } else {
  //             if (typeLimit == memberTypeCount) {
  //               isAllowed = false;
  //             } else {
  //               if (oneTypeAllowedPacks.includes(pack)) {
  //                 isAllowed = true;
  //               }
  //             }
  //           }

  //           return (
  //             <div
  //               key={type.id}
  //               className="flex justify-between items-center mb-4 p-2 border-b"
  //             >
  //               <div>
  //                 <h4 className="font-medium">{type.type}</h4>
  //                 {!isAllowed && (
  //                   <p className="text-red-500 text-sm">
  //                     Membership upgrade required
  //                   </p>
  //                 )}
  //               </div>

  //               {isAttending ? (
  //                 <button
  //                   onClick={() => cancelAttendance(event.id , type.id)}
  //                   className="bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded"
  //                 >
  //                   Cancel
  //                 </button>
  //               ) : (
  //                 <button
  //                   onClick={() => confirmAttendance(type.type, type.id)}
  //                   disabled={!isAllowed}
  //                   className={`px-4 py-1 rounded ${
  //                     isAllowed
  //                       ? "bg-green-500 hover:bg-green-600 text-white"
  //                       : "bg-gray-300 text-gray-500 cursor-not-allowed"
  //                   }`}
  //                 >
  //                   Confirm
  //                 </button>
  //               )}
  //             </div>
  //           );
  //         })}
  //       </Modal>
  //     </div>
  //   );
}